<template>
  <div class="flex w-full max-w-md flex-col gap-6">
    <img
      v-if="summary.vehicleImageUrl"
      :src="summary.vehicleImageUrl"
      :alt="vehicleTitle"
      class="max-h-[min(45vh,18rem)] w-full object-contain object-left"
    />
    <div
      v-else
      class="flex aspect-[4/3] w-full max-w-xs items-center justify-center rounded-lg bg-white/60"
    >
      <img src="@/assets/carvia_logo.svg" alt="Carvia" class="w-24 opacity-40" />
    </div>

    <p class="text-2xl font-bold leading-tight">
      {{ vehicleTitle }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { ProcessSessionBookingSummaryDto } from '@carvia/ros-client-types';
import { computed } from 'vue';

const props = defineProps<{
  summary: ProcessSessionBookingSummaryDto;
}>();

const vehicleTitle = computed(() =>
  `${props.summary.vehicleMake} ${props.summary.vehicleModel}`.trim(),
);
</script>
